import React from 'react'
import styled from 'styled-components'
import { H6, fonts, SmallText } from 'app/common/typography'
import { Link } from 'app/common/link'
import { colors } from 'shared/assets/styles'
import { Pin, CirclePencil } from 'app/assets/icons'
import { OpeningStatus } from 'app/common/restaurant'
import type { RestaurantShortDTO } from 'shared/types'

const { text, red, yellow } = colors
const { flameBold } = fonts

type Props = {
    restaurant?: RestaurantShortDTO,
    url: string
}

const WidgetEditRestaurant = (props: Props) => {
    const { restaurant, url } = props

    if (!restaurant) {
        return null
    }
    const {
        cacStatus,
        name,
        id,
        addressFull,
        distance,
        openingCacHour,
        closingCacHour
    } = restaurant

    return (
        <Widget url={url}>
            <RestaurantContainer>
                <Pin />
                <Infos>
                    <ColumnContainer>
                        <Title>
                            <H6>{name}</H6>
                        </Title>
                        <Address>{addressFull}</Address>
                        {cacStatus && (
                            <OpeningStatus
                                id={id}
                                status={cacStatus}
                                openingHour={openingCacHour}
                                closingHour={closingCacHour}
                                clickAndCollect
                            />
                        )}
                    </ColumnContainer>
                </Infos>
            </RestaurantContainer>
            <DistanceContainer>
                <StyledText>{distance}</StyledText>
                <CirclePencil color={yellow} stroke={yellow} size={25} />
            </DistanceContainer>
        </Widget>
    )
}

const Widget = styled(Link)`
    padding: 15px;
    background-color: white;
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 5px 20px 10px;
    width: 180%;
`
const RestaurantContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding: 5px;
    margin-left: 12px;
`
const Infos = styled.div`
    width: 100%;
    margin-left: 30px;
`
const ColumnContainer = styled.div`
    flex: 3;
`
const Title = styled.div`
    display: flex;
`
const Address = styled(SmallText)`
    color: ${text};
    margin: 5px 0 0px;
`
const DistanceContainer = styled.div`
    margin-top: 2px;
`
const StyledText = styled.div`
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 15px;
    font-family: ${flameBold};
    color: black;
`
export { WidgetEditRestaurant }
